import * as PIXI from 'pixi.js'
import _ from 'underscore'
import koko from './koko'

export const views = {
	pool: {},
	add: function(name, view, parent) {
		view.name = name;
        koko.views.pool[name] = view;
		//add to parent container
		if(parent != null) {
			if (typeof parent == 'string' || parent instanceof String) {
				koko.views.pool[parent].container.addChild( view.container );
			} else {
				parent.addChild(view.container);
			}
		}
	},
	get: function(name) {
		return koko.views.pool[name];
	},
	getMany: function(names) {
		if(names == null) {
			return false;
		}
		if(names.length == null) {
			names = [names];
		}

		var views = [];
		for(var key in names) {
			var name = names[key];
			var view = this.get(name);
			if(view) {
				views.push(view);
			}
		}

		return views;
	},
	getAll: function() {
		return koko.views.pool;
	},
	getAllBut: function(names) {
		if(names == null) {
			return false;
		}
		if(names.length == null) {
			names = [names];
		}

		var allViews = this.getAll();
		var views = [];
		for(var viewKey in allViews) {
			var view = allViews[viewKey];
			var ignore = false;
			for(var nameKey in names) {
				var name = names[nameKey];
				if(viewKey === name) {
					ignore = true;
				}
			}
			if(!ignore) {
				views.push(view);
			}
		}
		return views;
	},
	destroy: function(name) {
		var view = koko.views.pool[name];
		if(view.container.parent != null) view.container.parent.removeChild(view.container);
		delete koko.views.pool[name];
	},
	each: function(views, method) {
	   for( var i = 0; i < views.length; i++ ) {
			var view = koko.views.get(views[i]);
      if(!view) {
          console.log(views[i],'is not a view');
          continue;
      }
      if (typeof method == 'string' || method instanceof String) {
				if(method in view) {
					view[method].call(view);
				}
			} else {
				method(view);
			}
		}
	},
	all: function(method) {
		var names = [];
		for( var key in koko.views.pool ) names.push(key);
		koko.views.each(names, method);
	},
	allBut: function(ignoreArray, method) {
		var names = [], ignore = false;
		for( var key in koko.views.pool ) {
			ignore = false;
			for( var i = 0; i < ignoreArray.length; i++ ) {
				if(ignoreArray[i] === key) ignore = true;
			}
			if(!ignore) names.push(key);
		}
		koko.views.each(names, method);
	},
	filter: function(_func, method){
		var names = [];
		for( var key in koko.views.pool ) {
			if(_func(koko.views.pool[key], key)) names.push(key);
		}
		koko.views.each(names, method);
	},
	allVisible: function(method) {
		koko.views.filter(function(v, k){
			return v.container.visible && _.size(v.children) > 0;
		}, method);
	}
}

export class view {
    container = null;
    assets = null;
    children = null;
    elements = null;

    constructor(){
		this.container = new PIXI.Container();
		this.assets = [];
		this.children = [];
		this.elements = [];
		this.hide();
    }

    queueAssets(){
        koko.assets.addToManifest(this.assets);
    }

    buildView(){}
    transitionIn(){}
    transitionOut(){}
    resize(){}

    enable() {
        for(var i = 0; i < this.elements.length; i++) {
            this.elements[i].enable();
        }
    }

    disable(){
        for(var i = 0; i < this.elements.length; i++) {
            this.elements[i].disable();
        }
    }

    show() {
        this.container.visible = true;
    }

    hide(){
        this.container.visible = false;
    }

    destroyView(){ this.destroy(); }
    
    destroy(){
       koko.display.destroyContainerChildren(this.container);
       this.children = null;
    }
}
